<template>
  <div class="home">
    <section class="hero">
      <img class="hero__logo" :src="logoUrl" alt="Idoing" width="72" height="72" />
      <p class="hero__eyebrow">Developer Platform</p>
      <h1 class="hero__brand">Idoing</h1>
      <!-- <p class="hero__lead">把生成能力变成可调用的 API。<br />文档、密钥、用量与调试，一套面板搞定。</p> -->
      <div class="hero__actions">
        <router-link to="/type/all" class="btn btn-primary">浏览所有产品</router-link>
        <router-link to="/playground" class="btn btn-ghost">打开调试台</router-link>
      </div>
      <div class="hero__code panel mono" aria-hidden="true">
        <div class="hero__code-bar">
          <span></span><span></span><span></span>
          <em>curl · images.generations</em>
        </div>
        <pre>{{ curlSample }}</pre>
      </div>
    </section>

    <section class="features">
      <article v-for="f in features" :key="f.title" class="feature panel">
        <h3>{{ f.title }}</h3>
        <p>{{ f.desc }}</p>
      </article>
    </section>
  </div>
</template>

<script>
import { BRAND_LOGO_URL } from '../utils/brand'

export default {
  name: 'Home',
  data() {
    return {
      logoUrl: BRAND_LOGO_URL,
      curlSample: `curl https://open.pluskeji.cn/idoing_gpt_image \\
  -H "Authorization: Bearer $USER_TOKEN" \\
  -H "Content-Type: application/json" \\
  -d '{"prompt":"cyberpunk cat","model":"gpt-image-2","size":"1024x1024"}'`,
      features: [
        // {
        //   title: '主站同款登录',
        //   desc: '手机验证码 / 密码 / 邮箱验证码，接口与主站一致，登录后即可调试。'
        // },
        // {
        //   title: '自有 /idoing_* 封装',
        //   desc: '后端 IdoingProductController 提供 /idoing_*；上游密钥只留在服务端。'
        // },
        {
          title: '开发文档',
          desc: '参数、cURL 示例与控制器方法一一对应。'
        },
        {
          title: '在线调试',
          desc: '调试台直连 /idoing_*，自动带上登录 Token。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.hero {
  padding: 24px 0 40px;
  animation: rise 0.55s ease both;
}
.hero__logo {
  width: 72px;
  height: 72px;
  object-fit: contain;
  display: block;
  margin-bottom: 16px;
  border-radius: 16px;
  background: #0a0a0a;
}
.hero__eyebrow {
  margin: 0 0 10px;
  font-family: var(--font-mono);
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--accent);
}
.hero__brand {
  margin: 0;
  font-family: var(--font-display);
  font-size: clamp(48px, 10vw, 88px);
  font-weight: 800;
  letter-spacing: -0.05em;
  line-height: 0.95;
  background: linear-gradient(120deg, #f2fff7 20%, #7dffb3 70%, #5eead4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.hero__lead {
  margin: 18px 0 0;
  max-width: 520px;
  font-size: 17px;
  line-height: 1.65;
  color: var(--muted);
}
.hero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
}
.hero__code {
  margin-top: 36px;
  overflow: hidden;
  animation: rise 0.7s 0.08s ease both;
}
.hero__code-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--line);
  background: rgba(0, 0, 0, 0.25);
}
.hero__code-bar span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
}
.hero__code-bar em {
  margin-left: 10px;
  font-style: normal;
  font-size: 11px;
  color: var(--muted);
}
.hero__code pre {
  margin: 0;
  padding: 16px 18px 20px;
  font-size: 12.5px;
  line-height: 1.65;
  color: rgba(210, 255, 230, 0.88);
  overflow-x: auto;
}
.features {
  display: grid;
  gap: 14px;
  animation: rise 0.65s 0.12s ease both;
}
@media (min-width: 700px) {
  .features {
    grid-template-columns: 1fr 1fr;
  }
}
.feature {
  padding: 22px 20px;
}
.feature h3 {
  margin: 0 0 8px;
  font-size: 16px;
}
.feature p {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--muted);
}
@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
</style>
